export default __webpack_public_path__ + "static/media/Discover.81e0c359.jpg";